var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPauseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.073,
    height: 24.073,
    viewBox: "0 0 24.073 24.073",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "pause-icon",
    d: "M7.738,26.253H2.579A2.58,2.58,0,0,1,0,23.674V4.759A2.58,2.58,0,0,1,2.579,2.18H7.738a2.58,2.58,0,0,1,2.579,2.579V23.674A2.58,2.58,0,0,1,7.738,26.253Zm16.336-2.579V4.759A2.58,2.58,0,0,0,21.494,2.18H16.336a2.58,2.58,0,0,0-2.579,2.579V23.674a2.58,2.58,0,0,0,2.579,2.579h5.159A2.58,2.58,0,0,0,24.073,23.674Z",
    transform: "translate(0 -2.18)",
    fill: "#fbf8fd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseIcon);
export default __webpack_public_path__ + "static/media/pause-icon.965ad2cbe884b1c385c67a3d2da4fe0f.svg";
export { ForwardRef as ReactComponent };